import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getCompareNPIDetails } from "../../../actions/CompareNPI";
import CompareNpiModal from "../components/CompareNpiModal";

const mapStateToProps = ({
  compareNPIDetailsState,
  loggedInUserState,
}: ApplicationState) => ({
  compareNPIData: compareNPIDetailsState.response,
  loggedInUser: loggedInUserState.response,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getCompareNPIDetails: (userId: string) => {
      dispatch(getCompareNPIDetails(userId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareNpiModal);
